import { formatAmount, getIcon, catColor, catTint } from '../../lib/constants';
import { useAmountsVisibility } from '../../context/AmountsVisibilityContext';
import { Skeleton } from '../ui/skeleton';

// "¿En qué se va tu pisto?" (redesign.md, Fase 4): the three categories with
// the most spending this period, each with its budget state in words — never
// color alone. Categories without a budget just show what was spent.
export default function TopCategories({ categories = [], loading = false, onOpenCategories }) {
  const { hidden } = useAmountsVisibility();
  const money = (v) => formatAmount(v, hidden);
  // Spending categories only. An income category can still carry `spent`
  // (expenses filed under it, e.g. Gmail-detected transfers) — those don't
  // answer "where does your money go", so they stay out of the top 3.
  const top = categories
    .filter(c => c.type !== 'income' && (c.spent || 0) > 0)
    .sort((a, b) => b.spent - a.spent)
    .slice(0, 3);

  return (
    <section data-testid="top-categories">
      <h2 className="text-lg font-semibold tracking-tight text-white mb-3">¿En qué se va tu pisto?</h2>
      {loading ? (
        <div className="grid grid-cols-3 gap-2.5">
          {[0, 1, 2].map(i => <Skeleton key={i} className="h-[104px] rounded-2xl bg-white/[0.04]" />)}
        </div>
      ) : top.length === 0 ? (
        <p className="text-sm text-slate-500">Todavía no hay gastos en este periodo.</p>
      ) : (
        <div className="grid grid-cols-3 gap-2.5">
          {top.map(cat => {
            const Icon = getIcon(cat.icon);
            const hasBudget = (cat.budget || 0) > 0;
            const over = hasBudget ? cat.spent - cat.budget : 0;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={onOpenCategories}
                className="glass-card rounded-2xl p-3 text-left min-w-0 flex flex-col gap-2 active:scale-[0.97] transition-transform"
                data-testid={`top-category-${cat.id}`}
              >
                <span className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: catTint(cat.color) }}>
                  <Icon className="w-4 h-4" style={{ color: catColor(cat.color) }} />
                </span>
                <span className="min-w-0">
                  <span className="block text-xs text-slate-400 truncate">{cat.name}</span>
                  <span className="block text-base font-semibold text-white metric-value truncate">{money(cat.spent)}</span>
                  <span className={`block text-[11px] leading-tight mt-0.5 truncate ${over > 0 ? 'text-rose-400 font-medium' : 'text-slate-500'}`}>
                    {!hasBudget ? 'Sin límite'
                      : over > 0 ? `+${money(over)} de más`
                      : `Quedan ${money(-over)}`}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
}
